// The route where the full notifications screen lives. Single source so the
// bell, dropdown, and App router agree. Not iOS-blocked.

export const NOTIFICATIONS_ROUTE = "/notificacoes";
